// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackForm-cls1_ij_","cls2":"FeedbackForm-cls2_QON FeedbackForm-cls1_ij_"};